import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useChangePassword, useUpdateSecuritySettings } from "../../hooks/useSecurity";
import { errorMessage } from "../../hooks/useServers";

const MAX_OPTIONS = [[30, "30 días"], [60, "60 días"], [90, "90 días"], [180, "6 meses"], [365, "1 año"], [0, "Nunca"]];

// Formulario de cambio de contraseña (también lo usa el aviso obligatorio cuando la contraseña venció).
export function ChangePasswordForm({ onChanged, submitLabel = "Cambiar contraseña" }) {
  const change = useChangePassword();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [error, setError] = useState("");
  const ready = current && next.length >= 12 && next === again;
  const submit = async () => {
    setError("");
    try {
      await change.mutateAsync({ current_password: current, new_password: next });
      setCurrent("");
      setNext("");
      setAgain("");
      if (onChanged) onChanged();
    } catch (e) {
      setError(errorMessage(e, "No se pudo cambiar la contraseña."));
    }
  };
  return (
    <div data-testid="password-form" className="space-y-2">
      <Input data-testid="password-current" type="password" autoComplete="current-password" placeholder="Contraseña actual" value={current} onChange={(e) => setCurrent(e.target.value)} />
      <Input data-testid="password-new" type="password" autoComplete="new-password" placeholder="Contraseña nueva (mínimo 12 caracteres)" value={next} onChange={(e) => setNext(e.target.value)} />
      <Input data-testid="password-again" type="password" autoComplete="new-password" placeholder="Repite la contraseña nueva" value={again} onChange={(e) => setAgain(e.target.value)} />
      {next && next.length < 12 && <p className="text-xs text-muted-foreground">Usa una frase larga y única (mínimo 12 caracteres). No puede repetir tus últimas 5.</p>}
      {next && again && next !== again && <p className="text-xs text-amber-500">Las dos contraseñas no coinciden.</p>}
      <Button data-testid="password-save" size="sm" disabled={!ready || change.isPending} onClick={submit}>{submitLabel}</Button>
      {error && <p data-testid="password-error" className="text-xs text-amber-500">{error}</p>}
    </div>
  );
}

// Contraseña: cambiarla y cada cuánto vence (te avisa antes; al vencer te deja entrar y te pide cambiarla, nunca te deja fuera).
export function PasswordSection({ status }) {
  const update = useUpdateSecuritySettings();
  const [changed, setChanged] = useState(false);
  const [error, setError] = useState("");
  const left = status.password_days_left;
  const setMax = async (value) => {
    setError("");
    try {
      await update.mutateAsync({ password_max_days: Number(value) });
    } catch (e) {
      setError(errorMessage(e, "No se pudo guardar."));
    }
  };
  return (
    <div data-testid="password-section" className="space-y-3">
      <p data-testid="password-state" className="text-sm">
        {left === null ? "Tu contraseña no vence." : left < 0 ? "🔴 Tu contraseña venció: cámbiala ahora." : left <= 14 ? `🟡 Tu contraseña vence en ${left} día(s).` : `✅ Tu contraseña vence en ${left} días.`}
      </p>
      <label className="flex items-center gap-2 text-xs text-muted-foreground">
        Pedir cambio cada
        <select data-testid="password-max" value={status.password_max_days} onChange={(e) => setMax(e.target.value)} className="h-8 rounded-md border border-input bg-background px-2 text-sm text-foreground">
          {MAX_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
        </select>
      </label>
      <ChangePasswordForm onChanged={() => setChanged(true)} />
      {changed && <p data-testid="password-changed" className="text-xs text-emerald-500">Contraseña cambiada. Se cerraron tus otras sesiones.</p>}
      {error && <p className="text-xs text-amber-500">{error}</p>}
    </div>
  );
}
